import React from "react";

const LeaguesIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.62978 21.8496H2.01953V12.7571C2.01953 11.7175 2.99093 10.8721 4.18534 10.8721H5.94896V11.4705H4.18534C3.32767 11.4705 2.62978 12.0477 2.62978 12.7571V21.8496Z"
        fill="currentColor"
      />
      <path
        d="M4.96973 22.1484V21.55C6.0543 21.55 6.93639 20.8155 6.93639 19.913V11.1709H7.54663V19.913C7.54663 21.1458 6.39049 22.1484 4.96973 22.1484Z"
        fill="currentColor"
      />
      <path
        d="M17.2304 21.8488H16.6201V15.432C16.6201 14.3923 17.5915 13.5469 18.7859 13.5469H20.5495V14.1453H18.7859C17.9283 14.1453 17.2304 14.7225 17.2304 15.432V21.8488Z"
        fill="currentColor"
      />
      <path
        d="M19.5703 22.1471V21.5487C20.6549 21.5487 21.537 20.8142 21.537 19.9117V13.8457H22.1472V19.9117C22.1472 21.1445 20.9911 22.1471 19.5703 22.1471Z"
        fill="currentColor"
      />
      <path
        d="M9.98622 21.8484H9.37598V8.33625C9.37598 7.2966 10.3474 6.45117 11.5418 6.45117H13.3054V7.04961H11.5418C10.6841 7.04961 9.98622 7.62683 9.98622 8.33625V21.849V21.8484Z"
        fill="currentColor"
      />
      <path
        d="M12.3262 22.1473V21.5488C13.4107 21.5488 14.2928 20.8144 14.2928 19.9118V6.75H14.9031V19.9124C14.9031 21.1452 13.7469 22.1478 12.3262 22.1478V22.1473Z"
        fill="currentColor"
      />
      <path
        d="M13.3329 5.27569H12.6916V2.90533C12.4574 3.12022 12.1812 3.27908 11.8633 3.3819V2.81121C12.0308 2.75735 12.2122 2.65562 12.4086 2.50546C12.605 2.35531 12.7393 2.18067 12.8125 1.98047H13.3329V5.27569Z"
        fill="currentColor"
      />
      <path
        d="M6.07897 9.10296V9.68725H3.83105C3.85546 9.46637 3.92814 9.25692 4.05019 9.05944C4.17168 8.86195 4.41245 8.59973 4.77138 8.27276C5.06042 8.00891 5.23794 7.82937 5.30341 7.7358C5.39161 7.60578 5.436 7.47793 5.436 7.35062C5.436 7.21026 5.39772 7.10254 5.32061 7.02747C5.24349 6.95239 5.13753 6.91431 5.00217 6.91431C4.86681 6.91431 4.76196 6.95402 4.68262 7.03291C4.60329 7.11179 4.5578 7.24345 4.5456 7.42679L3.9065 7.36422C3.94478 7.01822 4.06405 6.76959 4.26488 6.6189C4.46571 6.4682 4.71701 6.39258 5.01825 6.39258C5.34834 6.39258 5.60798 6.47962 5.7966 6.65426C5.98522 6.82889 6.07953 7.04596 6.07953 7.30547C6.07953 7.45345 6.05235 7.59381 5.99853 7.7271C5.94472 7.86093 5.85873 8.00074 5.74167 8.14655C5.66401 8.24338 5.52421 8.3832 5.32172 8.56491C5.11923 8.74716 4.99107 8.86794 4.93726 8.92724C4.88345 8.98708 4.83962 9.04529 4.80578 9.10187H6.07953L6.07897 9.10296Z"
        fill="currentColor"
      />
      <path
        d="M18.9131 11.576L19.5339 11.502C19.5538 11.6571 19.6071 11.7757 19.6936 11.8578C19.7802 11.94 19.8856 11.9808 20.0088 11.9808C20.1413 11.9808 20.2523 11.9313 20.3433 11.8328C20.4337 11.7343 20.4792 11.6016 20.4792 11.4346C20.4792 11.2763 20.4359 11.1511 20.3494 11.0586C20.2628 10.9662 20.1569 10.9199 20.032 10.9199C19.9499 10.9199 19.8518 10.9357 19.7375 10.9667L19.8085 10.4542C19.9821 10.4586 20.1142 10.4216 20.2057 10.3432C20.2972 10.2649 20.3427 10.161 20.3427 10.031C20.3427 9.92052 20.3094 9.83239 20.2423 9.7671C20.1752 9.70127 20.0864 9.66863 19.9755 9.66863C19.8645 9.66863 19.7724 9.70617 19.6948 9.7807C19.6171 9.85524 19.5699 9.96404 19.5533 10.1077L18.9625 10.0092C19.0035 9.81063 19.0656 9.65231 19.1483 9.53371C19.231 9.41511 19.3469 9.32208 19.495 9.25408C19.6432 9.18607 19.8096 9.15234 19.9938 9.15234C20.3089 9.15234 20.5613 9.25081 20.7516 9.44775C20.9086 9.60879 20.9868 9.79104 20.9868 9.99397C20.9868 10.2818 20.8265 10.5119 20.5053 10.6833C20.6972 10.7235 20.8503 10.8138 20.9652 10.9542C21.08 11.0945 21.1377 11.2637 21.1377 11.4623C21.1377 11.7501 21.0306 11.996 20.8159 12.1989C20.6012 12.4019 20.3344 12.5031 20.0149 12.5031C19.712 12.5031 19.4612 12.4176 19.2615 12.2468C19.0623 12.076 18.9464 11.8524 18.9147 11.5766L18.9131 11.576Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LeaguesIcon;
